/*
* define todos los tipos de representar un botón que sirve para encapsular un componente
*/
export enum BotonTipo {
    button = "button",
    icon = "icon"
}